<div class="headerFlexW pr-4 m-3" *ngIf="company">
    <div class="content-block">
        <p class="bread-crumbs">
            <a [routerLink]="['/dash/companies/']" *ngIf="udta.level <= 3">Empresas</a>
            <span *ngIf="udta.level <= 3"> /</span> Detalle de empresa
        </p>
        <h2 class="">Empresa / {{company.companyName}}</h2>
    </div>
</div>
<div class="dx-card content-block" *ngIf="company">
    <div class="responsive-paddings">
        <h2 class="">Datos Generales</h2>
        <div class="flex flex-nowrap flex-space-between datagrid-detailsW  round-border-2">
            <div class="">
                <h2>Datos generales</h2>
                <ul>
                    <li>{{company.companyName}}</li>
                    <li>{{company.companyLegalName}}</li>
                    <li class="uper-case">RFC: {{company.rfc}}</li>
                    <li>Tel: {{company.companyPhone}}</li>
                    <li>CLABE: {{company.cuentaClabeSTP}}</li>
                    <li>Dirección: {{company.address.street}}, {{company.address.number}},
                        {{company.address.neighborhood}}</li>
                    <li>{{company.address.city}}, {{company.address.state}},
                        {{company.address.country}},
                        {{company.address.zip}}
                    </li>
                </ul>
            </div>
            <div class="">
                <h2>Datos de bancarios</h2>
                <ul>
                    <li>{{company.bank.name}}</li>
                    <li>{{company.bank.titular}}</li>
                    <li>{{company.bank.account}}</li>
                    <li>{{company.bank.clabe}}</li>
                </ul>
            </div>
            <div class="">
                <h2>Datos de contacto</h2>
                <ul>
                    <li>{{company.contactName}} {{company.contactLastName}}
                        {{company.contactSecondLastName}}
                    </li>
                    <li>{{company.contactEmail}}</li>
                    <li>{{company.contactPhone}}</li>
                </ul>
            </div>
            <div class="">
                <h2>Documentos</h2>
                <ul>
                    <li>
                        <a [href]="docs.logo" target="_blank" *ngIf="docs.logo"><i
                                class="far fa-check-square mr-1 brand-color fa-lg"></i> Logo</a>
                        <span *ngIf="!docs.logo"><i class="fal fa-stop fa-lg  mr-1 "></i> Logo</span>
                    </li>
                    <li>
                        <a [href]="docs.rfc" target="_blank" *ngIf="docs.rfc"><i
                                class="far fa-check-square mr-1 brand-color fa-lg"></i> RFC</a>
                        <span *ngIf="!docs.rfc"><i class="fal fa-stop fa-lg  mr-1 "></i> RFC</span>
                    </li>
                    <li>
                        <a [href]="docs.actaConstitutiva" target="_blank" *ngIf="docs.actaConstitutiva"><i
                                class="far fa-check-square mr-1 brand-color fa-lg"></i> Acta Constitutiva</a>
                        <span *ngIf="!docs.actaConstitutiva"><i class="fal fa-stop fa-lg  mr-1 "></i> Acta
                            Constitutiva</span>
                    </li>
                    <li>
                        <a [href]="docs.comprobanteDomicilio" target="_blank" *ngIf="docs.comprobanteDomicilio"><i
                                class="far fa-check-square mr-1 brand-color fa-lg"></i> Comprobante de domicilio</a>
                        <span *ngIf="!docs.comprobanteDomicilio"><i class="fal fa-stop fa-lg  mr-1 "></i> Comprobante de
                            domicilio</span>
                    </li>
                    <li>
                        <a [href]="docs.id" target="_blank" *ngIf="docs.id">
                            <i class="far fa-check-square mr-1 brand-color fa-lg"></i>
                            <span> ID </span>
                        </a>
                        <span *ngIf="!docs.id"><i class="fal fa-stop fa-lg  mr-1 "></i> ID</span>
                    </li>
                    <li>
                        <a [href]="docs.efos" target="_blank" *ngIf="docs.efos">
                            <i class="far fa-check-square mr-1 brand-color fa-lg"></i>
                            <span>EFOS</span>
                        </a>
                        <span *ngIf="!docs.efos"><i class="fal fa-stop fa-lg  mr-1 "></i> EFOS</span>
                    </li>
                    <li>
                        <a [href]="docs.rpc" target="_blank" *ngIf="docs.rpc"><i
                                class="far fa-check-square mr-1 brand-color fa-lg"></i> Expediente RPC</a>
                        <span *ngIf="!docs.rpc"><i class="fal fa-stop fa-lg  mr-1 "></i> Expediente RPC</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="flex flex-nowrap flex-space-between mt-5">
            <!-- //IZQ -->
            <div class="w-70 sectionW">
                <div class="flex flex-nowrap flex-space-between flex-align-center">
                    <h2 class="">Programas</h2>
                    <div class="">
                        <dx-button text="" icon="plus" type="default" (onClick)="addProgram()" *ngIf="udta.level <= 3">
                        </dx-button>
                    </div>
                </div>
                <dx-data-grid id="gridContainer" [dataSource]="company.programs" [showBorders]="true" class="mt-2">
                    <dxo-load-panel [enabled]="true"></dxo-load-panel>
                    <dxi-column dataField="agreementNNumber" caption="Convenio" dataType="string" alignment="center">
                    </dxi-column>
                    <dxi-column caption="Programa" cellTemplate="btnTemplateProgram" alignment="center"></dxi-column>
                    <div *dxTemplate="let btn of 'btnTemplateProgram'">
                        <dx-button icon="" text="{{btn.data.programName}}"
                            (onClick)="viewCompanyProgram(btn.data.programId)" type="default">
                        </dx-button>
                    </div>
                    <dxi-column dataField="programId" caption="Contrato" cellTemplate="btnTemplate" alignment="center">
                    </dxi-column>
                    <div *dxTemplate="let btn of 'btnTemplate'">
                        <dx-button icon="" text="ver" (onClick)="verContrato()" type="default">
                        </dx-button>
                        <dx-button [disabled]="statusContrato != 1" icon="" text="firmar" (onClick)="firmarContrato()"
                            type="default" class="ml-2">
                        </dx-button>
                    </div>
                    <dxi-column dataField="programId" caption="" cellTemplate="btnTemplateEditar" [width]='80'
                        alignment="center"></dxi-column>
                    <div *dxTemplate="let btn of 'btnTemplateEditar'">
                        <dx-button [disabled]="statusContrato > 0 || udta.level > 3" [visible]="udta.level < 4"
                            icon="edit" text="" (onClick)="editarEmpresa(btn.value)" type="default">
                        </dx-button>
                    </div>
                </dx-data-grid>

                <!-- <div class="pl-2 pr-2" *ngFor="let prog of company.programs">
                    <div class="">{{prog.programName}} - {{prog.agreementNNumber}} </div>
                </div> -->
            </div>
            <!-- DERECHA  -->
            <div class="w-30 sectionW">
                <div class="flex flex-nowrap flex-space-between flex-align-center">
                    <h2 class="">Documentos</h2>
                </div>
                <div class="round-border">
                    <!-- LOGO -->
                    <div>
                        <!-- <label class="title">Logo</label> -->
                        <form id="form_logo" [formGroup]="uploadLogoForm" enctype="multipart/form-data">
                            <div class="uploadW">
                                <div *ngIf="!company.docs.logo" class="uploaddContent">
                                    <div class='dx-field-value'>
                                        <label class="image-upload-container btn btn-bwm">
                                            <i class="dx-icon-file"></i>
                                            <span>Seleccionar Logo</span>
                                            <input #imageInput type="file" accept="image/*"
                                                (change)="onChangeFile($event,1)" placeholder="Seleccionar Logo">
                                            <div *ngIf="response_upload === 4">
                                                <div class=""><i class="far fa-check status-2 status-ico"></i>Carga
                                                    completa</div>
                                            </div>
                                            <div *ngIf="response_upload === 5">
                                                <div class=""><i class="fas fa-times status-4 status-ico"></i>No se
                                                    cargó el archivo</div>
                                            </div>
                                        </label>
                                        <div class="txt-sm">Archivos permitidos .jpg y .png</div>
                                    </div>
                                    <div class="txt-right">
                                        <dx-button [disabled]="UploadType != 1 || disabledButton" type="default" stylingMode="contained"
                                            (onClick)="onSubmitFile($event,1)" [height]="40"
                                            [width]="80">
                                            <div *dxTemplate="let data of 'content'">
                                                <dx-load-indicator class="button-indicator"
                                                    [visible]="loadIndicatorVisible">
                                                </dx-load-indicator>
                                                <span class="dx-button-text">{{ buttonText }}</span>
                                            </div>
                                        </dx-button>
                                        <div *ngIf="UploadType == 1" class="txt-sm">{{fileName}}</div>
                                    </div>
                                </div>
                                <div *ngIf="!company.docs.rfc" class="uploaddContent">
                                    <div class='dx-field-value'>
                                        <label class="image-upload-container btn btn-bwm">
                                            <i class="dx-icon-file"></i>
                                            <span>Seleccionar RFC</span>
                                            <input #imageInput type="file" accept=".pdf"
                                                (change)="onChangeFile($event,2)">
                                            <div *ngIf="response_upload === 4">
                                                <div class=""><i class="far fa-check status-2 status-ico"></i>Carga
                                                    completa</div>
                                            </div>
                                            <div *ngIf="response_upload === 5">
                                                <div class=""><i class="fas fa-times status-4 status-ico"></i>No se
                                                    cargó el archivo</div>
                                            </div>
                                        </label>
                                        <div class="txt-sm">Archivos permitidos .pdf</div>
                                    </div>
                                    <div class="txt-right">
                                        <dx-button [disabled]="UploadType != 2 || disabledButton" text="Subir" icon="" type="default"
                                            stylingMode="contained" (onClick)="onSubmitFile($event,2)"  [height]="40"
                                            [width]="80">
                                            <div *dxTemplate="let data of 'content'">
                                                <dx-load-indicator class="button-indicator"
                                                    [visible]="loadIndicatorVisible">
                                                </dx-load-indicator>
                                                <span class="dx-button-text">{{ buttonText }}</span>
                                            </div>
                                        </dx-button>
                                        <div *ngIf="UploadType == 2" class="txt-sm">{{fileName}}</div>
                                    </div>
                                </div>
                                <div *ngIf="!company.docs.actaConstitutiva" class="uploaddContent">
                                    <div class='dx-field-value'>
                                        <label class="image-upload-container btn btn-bwm">
                                            <i class="dx-icon-file"></i>
                                            <span>Acta Constitutiva</span>
                                            <input #imageInput type="file" accept=".pdf"
                                                (change)="onChangeFile($event,3)">
                                            <div *ngIf="response_upload === 4">
                                                <div class=""><i class="far fa-check status-2 status-ico"></i>Carga
                                                    completa</div>
                                            </div>
                                            <div *ngIf="response_upload === 5">
                                                <div class=""><i class="fas fa-times status-4 status-ico"></i>No se
                                                    cargó el archivo</div>
                                            </div>
                                        </label>
                                        <div class="txt-sm">Archivos permitidos .pdf</div>
                                    </div>
                                    <div class="txt-right">
                                        <dx-button [disabled]="UploadType != 3 || disabledButton" text="Subir" icon="" type="default"
                                            stylingMode="contained" (onClick)="onSubmitFile($event,3)" [height]="40"
                                            [width]="80">
                                            <div *dxTemplate="let data of 'content'">
                                                <dx-load-indicator class="button-indicator"
                                                    [visible]="loadIndicatorVisible">
                                                </dx-load-indicator>
                                                <span class="dx-button-text">{{ buttonText }}</span>
                                            </div>
                                        </dx-button>
                                        <div *ngIf="UploadType == 3" class="txt-sm">{{fileName}}</div>
                                    </div>
                                </div>
                                <div *ngIf="!company.docs.comprobanteDomicilio" class="uploaddContent">
                                    <div class='dx-field-value'>
                                        <label class="image-upload-container btn btn-bwm">
                                            <i class="dx-icon-file"></i>
                                            <span>Comprobante de Domicilio</span>
                                            <input #imageInput type="file" accept=".pdf"
                                                (change)="onChangeFile($event,4)">
                                            <div *ngIf="response_upload === 4">
                                                <div class=""><i class="far fa-check status-2 status-ico"></i>Carga
                                                    completa</div>
                                            </div>
                                            <div *ngIf="response_upload === 5">
                                                <div class=""><i class="fas fa-times status-4 status-ico"></i>No se
                                                    cargó el archivo</div>
                                            </div>
                                        </label>
                                        <div class="txt-sm">Archivos permitidos .pdf</div>
                                    </div>
                                    <div class="txt-right">
                                        <dx-button [disabled]="UploadType != 4 || disabledButton" text="Subir" icon="" type="default"
                                            stylingMode="contained" (onClick)="onSubmitFile($event,4)"  [height]="40"
                                            [width]="80">
                                            <div *dxTemplate="let data of 'content'">
                                                <dx-load-indicator class="button-indicator"
                                                    [visible]="loadIndicatorVisible">
                                                </dx-load-indicator>
                                                <span class="dx-button-text">{{ buttonText }}</span>
                                            </div>
                                        </dx-button>
                                        <div *ngIf="UploadType == 4" class="txt-sm">{{fileName}}</div>
                                    </div>
                                </div>
                                <div *ngIf="!company.docs.id" class="uploaddContent">
                                    <div class='dx-field-value'>
                                        <label class="image-upload-container btn btn-bwm">
                                            <i class="dx-icon-file"></i>
                                            <span>Seleccionar ID</span>
                                            <input #imageInput type="file" accept="image/*,.pdf"
                                                (change)="onChangeFile($event,5)">
                                            <div *ngIf="response_upload === 4">
                                                <div class=""><i class="far fa-check status-2 status-ico"></i>Carga
                                                    completa</div>
                                            </div>
                                            <div *ngIf="response_upload === 5">
                                                <div class=""><i class="fas fa-times status-4 status-ico"></i>No se
                                                    cargó el archivo</div>
                                            </div>
                                        </label>
                                        <div class="txt-sm">Archivos permitidos .pdf, .jpg, .png</div>
                                    </div>
                                    <div class="txt-right">
                                        <dx-button [disabled]="UploadType != 5 || disabledButton" text="Subir" icon="" type="default"
                                            stylingMode="contained" (onClick)="onSubmitFile($event,5)"  [height]="40"
                                            [width]="80">
                                            <div *dxTemplate="let data of 'content'">
                                                <dx-load-indicator class="button-indicator"
                                                    [visible]="loadIndicatorVisible">
                                                </dx-load-indicator>
                                                <span class="dx-button-text">{{ buttonText }}</span>
                                            </div>
                                        </dx-button>
                                        <div *ngIf="UploadType == 5" class="txt-sm">{{fileName}}</div>
                                    </div>
                                </div>

                                <!-- UPLOAD FILE EFOS -->
                                <div *ngIf="!company.docs.efos" class="uploaddContent">
                                    <div class='dx-field-value'>
                                        <label class="image-upload-container btn btn-bwm">
                                            <i class="dx-icon-file"></i>
                                            <span>Seleccionar EFOS</span>
                                            <input #imageInput type="file" accept="image/*,.pdf"
                                                (change)="onChangeFile($event,6)">
                                            <div *ngIf="response_upload === 4">
                                                <div class=""><i class="far fa-check status-2 status-ico"></i>Carga
                                                    completa</div>
                                            </div>
                                            <div *ngIf="response_upload === 5">
                                                <div class=""><i class="fas fa-times status-4 status-ico"></i>No se
                                                    cargó el archivo</div>
                                            </div>
                                        </label>
                                        <div class="txt-sm">Archivos permitidos .pdf, .jpg, .png</div>
                                    </div>
                                    <div class="txt-right">
                                        <dx-button [disabled]="UploadType != 6 || disabledButton" text="Subir" icon="" type="default"
                                            stylingMode="contained" (onClick)="onSubmitFile($event,6)"   [height]="40"
                                            [width]="80">
                                            <div *dxTemplate="let data of 'content'">
                                                <dx-load-indicator class="button-indicator"
                                                    [visible]="loadIndicatorVisible">
                                                </dx-load-indicator>
                                                <span class="dx-button-text">{{ buttonText }}</span>
                                            </div>
                                        </dx-button>
                                        <div *ngIf="UploadType == 6" class="txt-sm">{{fileName}}</div>
                                    </div>
                                </div>

                                <!-- UPLOAD EXPEDIENTE RPC -->
                                <div *ngIf="!company.docs.rpc" class="uploaddContent">
                                    <div class='dx-field-value'>
                                        <label class="image-upload-container btn btn-bwm">
                                            <i class="dx-icon-file"></i>
                                            <span>Seleccionar Expediente RPC</span>
                                            <input #imageInput type="file" accept="image/*,.pdf"
                                                (change)="onChangeFile($event,7)">
                                            <div *ngIf="response_upload === 4">
                                                <div class=""><i class="far fa-check status-2 status-ico"></i>Carga
                                                    completa</div>
                                            </div>
                                            <div *ngIf="response_upload === 5">
                                                <div class=""><i class="fas fa-times status-4 status-ico"></i>No se
                                                    cargó el archivo</div>
                                            </div>
                                        </label>
                                        <div class="txt-sm">Archivos permitidos .pdf, .jpg, .png</div>
                                    </div>
                                    <div class="txt-right">
                                        <dx-button [disabled]="UploadType != 7 || disabledButton" text="Subir" icon="" type="default"
                                            stylingMode="contained" (onClick)="onSubmitFile($event,7)"   [height]="40"
                                            [width]="80">
                                            <div *dxTemplate="let data of 'content'">
                                                <dx-load-indicator class="button-indicator"
                                                    [visible]="loadIndicatorVisible">
                                                </dx-load-indicator>
                                                <span class="dx-button-text">{{ buttonText }}</span>
                                            </div>
                                        </dx-button>
                                        <div *ngIf="UploadType == 7" class="txt-sm">{{fileName}}</div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <dx-popup [width]="300" [height]="250" [showTitle]="true" title="Nuevo programa" [dragEnabled]="false"
        [closeOnOutsideClick]="true" [(visible)]="popupVisible">
        <div *dxTemplate="let data of 'content'">
            <div class='dx-field mt-2'>
                <div class='dx-field-label'>Programa</div>
                <div class='dx-field-value'>
                    <dx-select-box [dataSource]="programsObj" displayExpr="programName" valueExpr=""
                        (onValueChanged)="checkPrograms($event.value)">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>
            </div>
            <div class="float-right">
                <dx-button id="button" class="" [useSubmitBehavior]="true" type="default"
                    (onClick)="addNewProgram($event)" text="Guardar programa">
                </dx-button>
            </div>
        </div>
    </dx-popup>
    <dx-popup [showTitle]="true" title="Firma" [dragEnabled]="false" [closeOnOutsideClick]="true"
        [(visible)]="firmaPopupVisible">
        <div *dxTemplate="let data of 'content'">
            <dx-scroll-view>
                <div id="mifiel-widget"></div>
            </dx-scroll-view>
        </div>
    </dx-popup>
    <dx-popup [showTitle]="true" title="Documento" [dragEnabled]="false" [closeOnOutsideClick]="true"
        [(visible)]="documentoPopupVisible">
        <div *dxTemplate="let data of 'content'">
            <iframe [src]="pdfSrc|safeUrl" name="archivo" ngDefaultControl frameborder="0" allow="encrypted-media"
                allowfullscreen allowtransparency="true">
            </iframe>
            <div>
                <dx-button [disabled]="statusContrato > 0" id="button" class="" [useSubmitBehavior]="true"
                    type="default" (onClick)="enviarAFirma()" text="Crear Contrato">
                </dx-button>
            </div>
        </div>
    </dx-popup>
</div>